import React, { CSSProperties } from "react";
import { Space, Tooltip } from "antd";
import { SupplierInsight } from "../../../../types/SupplierTypes";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { GenericCard } from "../../../../common/components/GenericCard";
import classes from "./InsightsCard.module.less";

interface InsightsCardProps {
    insights?: SupplierInsight[];
    tip?: string;
    style?: CSSProperties;
    orgName?: string;
}

export const InsightsCard: React.FC<InsightsCardProps> = ({ insights, tip, style, orgName }) => {
    if (!insights?.length) return null;

    return (
        <div style={style}>
            <div className={classes.titleRow}>
                <Space>
                    <span className="sectionTitle">Insights</span>
                    <Tooltip title={tip}>
                        <SvgIcon name="help" color="#1890FF" />
                    </Tooltip>
                </Space>
            </div>
            <GenericCard size="large">
                <ul className={classes.insights}>
                    {insights.map((item) => (
                        <li key={item.id} className={classes.insight}>
                            <div className={classes.insightTitle}>{item.title}: </div>
                            {item.content}
                            {item.implication && orgName ? (
                                <>
                                    <div className={classes.implication}>
                                        Implications for {orgName}:
                                    </div>
                                    {item.implication}
                                </>
                            ) : null}
                        </li>
                    ))}
                </ul>
            </GenericCard>
        </div>
    );
};
